const data = [
  { id: 0, name: "Sem contraditório" },
  { id: 1, name: "Aprovado" },
  { id: 2, name: "Rejeitado" },
  { id: 3, name: "Validado" },
];

export default [...data];